import { useCallback, useMemo } from 'react';
import { useAuthenticatedFetchWithWorkspace } from '../Keycloak/useAuthenticatedFetchWithWorkspace';
import { useCachedQuery } from './useCachedQuery';

export interface AvailableGroup {
    id: number;
    userId: number;
    description: string;
    source: string;
    updateDate: string;
}

type AvailableGroupsResponse = AvailableGroup[] | { member?: AvailableGroup[]; 'hydra:member'?: AvailableGroup[] };

const NO_GROUPS: AvailableGroup[] = [];

export const useAvailableGroups = () => {
    const { authFetch, workspaceId } = useAuthenticatedFetchWithWorkspace();

    const fetchGroups = useCallback(async (): Promise<AvailableGroup[]> => {
        const response: AvailableGroupsResponse = await authFetch('/getAvailableGroupsQuery', { method: 'GET' });
        if (Array.isArray(response)) return response;
        return response?.member ?? response?.['hydra:member'] ?? [];
    }, [authFetch]);

    const { data: groups, loading, refetch } = useCachedQuery(
        `available_groups:${workspaceId ?? 'none'}`,
        fetchGroups,
        NO_GROUPS,
        'Erreur de chargement des groupes',
    );

    return useMemo(() => ({ groups, loading, refetch }), [groups, loading, refetch]);
};
